import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Button, TextField, Box, IconButton, InputAdornment } from '@mui/material';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import TuneIcon from '@mui/icons-material/Tune';
import Iconify from '../../../../reusable-components/iconify';
import OrderOptions from './order-navbar/OrderOptions';
import CartTotalBox from './order-navbar/CartTotalBox';

FilterBar.propTypes = {
  filter: PropTypes.object.isRequired,
  setFilter: PropTypes.func.isRequired,
  setFilterDrawerOpen: PropTypes.func.isRequired,
};

export default function FilterBar({ filter, setFilter, setFilterDrawerOpen }) {
  const { searchAll, ...filtersWithoutSearchAll } = filter;

  const hasActiveFilters = Object.values(filtersWithoutSearchAll).some(
    (v) => v !== '' && v !== null && !(Array.isArray(v) && v.length === 0)
  );

  return (
    <Box>
      <Grid container alignItems="center" spacing={2}>
        <Grid item>
          <OrderOptions />
        </Grid>
        <Grid item>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {/* All Filters Button */}
            <Button
              color="secondary"
              size="small"
              variant={hasActiveFilters ? 'contained' : 'outlined'}
              startIcon={<TuneIcon />}
              onClick={() => setFilterDrawerOpen(true)}
            >
              All Filters
            </Button>

            {/* Clear All Filters */}
            {hasActiveFilters && (
              <Button
                variant="text"
                color="secondary"
                size="small"
                startIcon={<ClearAllIcon />}
                disableElevation
                sx={{ textDecoration: 'underline', ml: 1 }}
                onClick={() => {
                  setFilter({
                    search: '',
                    description: '',
                    manufacturers: [],
                    manufacturerSearch: '',
                    subcategories: [],
                    subcategorySearch: '',
                    minPrice: '',
                    maxPrice: '',
                    inCart: '',
                    sku: '',
                    productId: '',
                    vendor: [],
                    uom: '',
                    manufacturerId: '',
                    searchAll,
                  });
                  setFilterDrawerOpen(false);
                }}
              >
                Clear All Filters
              </Button>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ ml: 'auto' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <CartTotalBox />
            <TextField
              value={filter.searchAll || ''}
              onChange={(e) => setFilter((f) => ({ ...f, searchAll: e.target.value }))}
              size="small"
              placeholder="Search all"
              fullWidth
              autoComplete="off"
              sx={{
                mr: 2,
                '& .MuiOutlinedInput-root': {
                  height: 30,
                  borderRadius: '4px',
                  '& fieldset': {
                    borderColor: '#404042',
                  },
                  '&:hover fieldset': {
                    borderColor: '#404042',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#404042',
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      sx={{ display: filter.searchAll ? 'inline-flex' : 'none' }}
                      onClick={() => setFilter((f) => ({ ...f, searchAll: '' }))}
                    >
                      <Iconify icon="ri:close-fill" sx={{ cursor: 'pointer' }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
